import React, { type ReactNode } from 'react';
import { CheckboxGroup as AriaCheckboxGroup, type CheckboxGroupProps as AriaCheckboxGroupProps, composeRenderProps } from 'react-aria-components';
import { cn } from '../../../components/utils';
import type { BaseFieldProps } from '../../../components/types';
import { FieldWarning } from '../base-controls/FieldWarning';
import { FieldError } from '../base-controls/FieldError';
import { FieldDescription } from '../base-controls/FieldDescription';
import { FieldLabelWithHtml } from '../base-controls/FieldLabelWithHtml';

export interface CheckboxGroupFieldProps extends Omit<AriaCheckboxGroupProps, 'children'>, BaseFieldProps {
	warningMessage?: string;
	children?: ReactNode;
}

export function CheckboxGroupField(props: CheckboxGroupFieldProps & { orientation?: 'horizontal' | 'vertical' }) {
	const labelAndDescription =
		!props.hideLabel || props.description ? (
			<div>
				{!props.hideLabel && <FieldLabelWithHtml label={props.label} required={props.required} />}
				{props.description && <FieldDescription>{props.description}</FieldDescription>}
			</div>
		) : null;

	return (
		<AriaCheckboxGroup
			{...props}
			className={composeRenderProps(props.className, className =>
				cn('flex gap-4 relative', !props.orientation || props.orientation === 'vertical' ? 'flex-col' : 'flex-row', className)
			)}
			aria-label={props.label}
			isRequired={props.required}
		>
			{labelAndDescription}
			{props.children}
			{props.error && <FieldError {...props.error} />}
			<FieldWarning>{props.warningMessage}</FieldWarning>
		</AriaCheckboxGroup>
	);
}
